<template>
  <div style="padding-bottom: 60px" v-if="body_show">
    <public-top-tips v-show="data.uid && data.uid < 0"></public-top-tips>

    <div class="meacur_top">
      <h2>{{title}}</h2>
      <div class="meacur_tx">
        <img :src="userinfo.headimgurl" />
        <div class="meacur_txr">
          <h3>{{userinfo.nickname}}</h3>
          <h4>{{userinfo.ctime}}</h4>
        </div>
      </div>
    </div>
    <div class="meacur_main" style="margin-top: -30px;">
      <div class="mea_tb">
        职业发展现状
      </div>
      <div class="mea_h2">根据对你的职业掌控感和职业幸福感的综合评估，下图高亮部分即是你目前所处职业发展状态。</div>
      <div class="meacut_t1">
        <div class="meacut_zk">
          <h4>掌控感</h4>
          <div class="zk">
            <ul>
              <li>
                <img src="https://themes-cdn.xjy.cn/statics/career/images/zk11.png" v-if="group.strips == 2" />
                <img src="https://themes-cdn.xjy.cn/statics/career/images/zk1.png" v-else/>
              </li>
              <li>
                <img src="https://themes-cdn.xjy.cn/statics/career/images/zk22.png" v-if="group.strips == 1" />
                <img src="https://themes-cdn.xjy.cn/statics/career/images/zk2.png" v-else/>
              </li>
              <li>
                <img src="https://themes-cdn.xjy.cn/statics/career/images/zk33.png" v-if="group.strips == 3" />
                <img src="https://themes-cdn.xjy.cn/statics/career/images/zk3.png" v-else/>
              </li>
              <li>
                <img src="https://themes-cdn.xjy.cn/statics/career/images/zk44.png" v-if="group.strips == 4" />
                <img src="https://themes-cdn.xjy.cn/statics/career/images/zk4.png" v-else/>
              </li>
            </ul>
          </div>
          <h4 class="rig">幸福感</h4>
        </div>
        <div class="mea_vb">你目前职业健康度得分为 <span>{{group.avg_score}}</span>分，目前处于职业状态的 <span>{{group.quadrant}}</span></div>
        <div v-html="group.text" class="mea_fov"></div>
      </div>
      <div class="mea_fot">
        <div v-html="group.unscramble" class="mea_fov"></div>
      </div>
    </div>
    <div class="meacur_main">
      <div class="mea_tb">
        职业幸福感
      </div>
      <div class="mea_h2" style="margin-bottom: 10px;">职业幸福感是指在工作中自己的需要是否能得到满足、潜能是否能得到发挥、力量是否能得以增长，并能获得持续快乐的体验，简而言之，就是工作干的“是否开心”</div>
      <div class="mea_h2" style="margin-top: 0;">下图中用五个维度的得分，反应了你当下的职业幸福感，分数越高，幸福感越高。</div>
      <div class="meacut_t1">
        <div class="meacur_dv clearfix">
          <h4>幸福感</h4>
          <div class="">
            <div class="dv_top dv_top1">
              <span></span>优秀
            </div>
            <div class="dv_top dv_top2">
              <span></span>改进
            </div>
            <div class="dv_top">
              <span></span>常模
            </div>
          </div>
          <ul class="clearfix">
            <li v-for="(item,index) in model1.dimension.divide" :key="index" class="clearfix">
              <div :class="['dv_left',index==0?'dv_left1':'']">
                {{item.title}}
              </div>
              <div :class="['dv_right',index==0?'dv_right1':'',index==model1.dimension.divide.length-1?'dv_right2':'']">
                <h2 :class="{sum: item.avg_score>2}" :style="{width: 1.12*item.avg_score + 'rem'}"></h2>
                <h2 class="spe" :style="{width: 1.12*item.modelscore + 'rem'}"></h2>
                <dl :class="['clearfix',index==0?'dl1':'']">
                  <dt></dt>
                  <dt class="m1_dt"></dt>
                  <dt></dt>
                  <dt></dt>
                  <dt></dt>
                </dl>
              </div>
            </li>
          </ul>
          <div class="dv_bottom clearfix">
            <ul>
              <li>2分</li>
              <li class="b2">5分</li>
              <li class="b3">评分</li>
            </ul>
          </div>
        </div>
        <div class="mea_h2" v-html="model1.text"></div>
        <div v-if="model1.dimension.special==''">
          <div class="mea_h2" style="font-weight: bold;">{{model1.dimension.explainingheadtext}}</div>
          <div class="mea_h2" v-html="model1.dimension.explainingmiddletext"></div>
        </div>
        <div class="mea_h2" v-html="model1.dimension.special" v-else></div>
      </div>
      <div v-if="model1.dimension.special==''">
        <div class="mea_fot" v-if="!report">
          <h2>{{model1.dimension.explainingfoottext}}</h2>
        </div>
        <div class="mea_fot" v-else>
          <div v-html="model1.dimension.suggest" class="mea_fov"></div>
        </div>
      </div>
    </div>
    <div class="meacur_main">
      <div class="mea_tb">
        职业掌控感
      </div>
      <div class="mea_h2" style="margin-bottom: 10px;">职业掌控度，反应的是你对自身是否能够胜任当前工作的信心程度，直接感受就是工作做得“是否顺手”。</div>
      <div class="mea_h2" style="margin-top: 0;">下图用四个维度的得分状况来反应你的职业掌控度，分数越高，掌控感越强。</div>
      <div class="meacut_t1">
        <div class="meacur_dv clearfix">
          <h4>掌控度</h4>
          <div class="">
            <div class="dv_top dv_top1">
              <span></span>优秀
            </div>
            <div class="dv_top dv_top2">
              <span></span>改进
            </div>
            <div class="dv_top">
              <span></span>常模
            </div>
          </div>
          <ul class="clearfix">
            <li v-for="(item,index) in model2.dimension.divide" :key="index" class="clearfix">
              <div :class="['dv_left',index==0?'dv_left1':'']">
                {{item.title}}
              </div>
              <div :class="['dv_right',index==0?'dv_right1':'',index==model2.dimension.divide.length-1?'dv_right2':'']">
                <h2 :class="{sum: item.avg_score>2}" :style="{width: 1.12*item.avg_score + 'rem'}"></h2>
                <h2 class="spe" :style="{width: 1.12*item.modelscore + 'rem'}"></h2>
                <dl :class="['clearfix',index==0?'dl1':'']">
                  <dt></dt>
                  <dt class="m1_dt"></dt>
                  <dt></dt>
                  <dt></dt>
                  <dt></dt>
                </dl>
              </div>
            </li>
          </ul>
          <div class="dv_bottom">
            <ul>
              <li>2分</li>
              <li class="b2">5分</li>
              <li class="b3">评分</li>
            </ul>
          </div>
        </div>
        <div class="mea_h2" v-html="model2.text"></div>
        <div v-if="model2.dimension.special==''">
          <div class="mea_h2" style="font-weight: bold;">{{model2.dimension.explainingheadtext}}</div>
          <div class="mea_h2" v-html="model2.dimension.explainingmiddletext"></div>
        </div>
        <div class="mea_h2" v-html="model2.dimension.special" v-else></div>
      </div>
      <div v-if="model2.dimension.special==''">
        <div class="mea_fot" v-if="!report">
          <h2>{{model2.dimension.explainingfoottext}}</h2>
        </div>
        <div class="mea_fot" v-else>
          <h2>{{model2.dimension.suggesttitle}}</h2>
          <div v-html="model2.dimension.suggest" class="mea_fov"></div>
        </div>
      </div>
    </div>
    <div class="meacur_main">
      <div class="mea_tb">
        职业心智成熟度
      </div>
      <div class="mea_h2" style="margin-bottom: 10px;">心智成熟度是指职业信念上的成熟程度，反映的是你在心智方面“是否掉坑”</div>
      <div class="mea_h2" style="margin-top: 0;">下图是12个维度的得分状况，超过临界线的维度需要多多关注。</div>
      <div class="meacut_t1">
        <div class="meacur_dv clearfix">
          <h4>心智</h4>
          <div class="">
            <div class="dv_top dv_top1">
              <span></span>优秀
            </div>
            <div class="dv_top dv_top2">
              <span></span>改进
            </div>
            <div class="dv_top">
              <span></span>常模
            </div>
          </div>
          <ul class="clearfix">
            <li v-for="(item,index) in model3.dimension.divide" :key="index" class="clearfix">
              <div :class="['dv_left',index==0?'dv_left1':'']">
                {{item.title}}
              </div>
              <div :class="['dv_right',index==0?'dv_right1':'',index==model3.dimension.divide.length-1?'dv_right2':'']">
                <h2 :class="{sum: item.avg_score<=4}" :style="{width: 1.12*item.avg_score + 'rem'}"></h2>
                <h2 class="spe" :style="{width: 1.12*item.modelscore + 'rem'}"></h2>
                <dl :class="['clearfix',index==0?'dl1':'']">
                  <dt></dt>
                  <dt></dt>
                  <dt></dt>
                  <dt class="m1_dt"></dt>
                  <dt></dt>
                </dl>
              </div>
            </li>
          </ul>
          <div class="dv_bottom dv_bottom_spe">
            <ul>
              <li>2分</li>
              <li class="b4">4分</li>
              <li class="b3 b5">评分</li>
            </ul>
          </div>
        </div>
        <div class="mea_h2" v-html="model3.text"></div>
        <div v-if="model3.dimension.special==''">
          <div class="mea_h2" style="font-weight: bold;">{{model3.dimension.explainingheadtext}}</div>
          <div class="mea_h2" v-html="model3.dimension.explainingmiddletext"></div>
        </div>
        <div class="mea_h2" v-html="model3.dimension.special" v-else></div>
      </div>
      <div v-if="model3.dimension.special==''">
        <div class="mea_fot" v-if="!report">
          <h2>{{model3.dimension.explainingfoottext}}</h2>
        </div>
        <div class="mea_fot" v-else style="text-align: justify;">
          <h2>{{model3.dimension.suggesttitle}}</h2>
          <div v-html="model3.dimension.suggest" class="mea_fov"></div>
        </div>
      </div>
    </div>
    <div class="meacur_main" v-if="report">
      <div class="mea_tb">
        职业能力优势探索
      </div>
      <div class="mea_h2 mea_h2s">
        已经有<span>{{num}}</span>位伙伴，为你做出了客观评价，你的能力优势图如下，希望能带给你更多的启发，并有针对性的扬长避短，强化自己的优势。
      </div>
      <div class="mea_h2" style="margin-top: 0;">也可以邀请更多好友继续做评价，让自己的能力优势图更丰富，更有参考意义和价值。</div>
      <div class="yos clearfix">
        <div v-for="(item,index) in ability" :key="index" :class="['yos_main',index==ability.length-1?'yos_mainlast':'']">
          <h2>{{item.stitle}}</h2>
          <ul>
            <li v-for="(it,idx) in item.chirld" :key="idx" :class="{sun1: it.num ==1,sun2: it.num ==2,sun3: it.num >= 3}">
              <div class="yos_k">
                {{it.title}}
                <br/> <span v-if="it.num>0">-{{it.num}}-</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="meacur_main" v-if="!report">
      <div class="mea_tb">
        职业能力优势探索
      </div>
      <div class="mea_h2" style="font-weight: bold;margin-bottom: 10px;">根据职业发展健康指数评估，你已了解当下的职业发展状态，不过还有至关重要的一环等待你来完成。</div>
      <div class="mea_h2">在职场中，除幸福感、掌控感、心智成熟度以外，能力的高低是职场发展的核心，邀请你的好友帮你完成能力TA评，了解在别人眼中你的优势能力是什么，会帮助你更客观的认识和评估自己。</div>
      <div class="jas_main" style="margin-top: 0;">
        <h2>同时，成功邀请3位好友为你评价后，你将解锁完整版报告，获取各部分职场建议，全面开启你的职场加速路。</h2>
        <ul class="cep clearfix">
          <li class="clearfix">
            <img src="@a/ovs.png" />
            <p>测评</p>
          </li>
          <li class="clearfix" :class="{on: assistance.num>=1}">
            <h4></h4>
          </li>
          <li class="clearfix" :class="{on: assistance.num>=1}">
            <img src="@a/ovs.png" v-if="assistance.num>=1" />
            <img src="@a/ov2.png" v-else/>
            <p>他评</p>
          </li>
          <li class="clearfix spe" :class="{on: assistance.num>=3}">
            <h4></h4>
          </li>
          <li class="clearfix" :class="{on: assistance.num>=3}">
            <img src="@a/ovs.png" v-if="assistance.num>=3" />
            <img src="@a/ov3.png" v-else/>
            <p>获取完整
              <br/>测评报告</p>
          </li>
        </ul>
      </div>
      <div class="jas_v">
        <h2 v-if="assistance.num>0">他评+{{assistance.num}}</h2>
        <h2 v-else>暂无好友为你他评</h2>
        <ul class="clearfix">
          <li v-for="(item,index) in assistance.list" :key="index">
            <img :src="item.headimgurl" />
            <p>{{item.nickname}}</p>
          </li>
          <li v-for="(item,index) in (3-assistance.list.length)"  :key="index" v-if="assistance.list.length<=3">
            <img src="@a/txx.png" />
          </li>
        </ul>
      </div>
    </div>
    <!-- <div class="meacur_main">
      <div class="mea_tb">
        快速发展建议
      </div>
      <div class="jas_main">
        <ul class="j_v">
          <li v-for="(item,index) in onekey" class="clearfix"  :key="index">
            <div class="mea_h2">{{onekey_f[item.title]}}</div>
            <img :src="item.img" />
            <div class="jas_r">
              <h3>{{item.title}}<br/>{{item.subtitle}}</h3>
              <a :href="item.jumpurl">我要加速</a>
            </div>
          </li>
        </ul>
      </div>
    </div> -->
    <!--9.9职业发展进阶广告位  -->
    
    <div class="career-dev">
      <public-advertising></public-advertising>
    </div>

    <public-ad-qrcode></public-ad-qrcode>
    
    <!--  -->
    <div class="men_foots">
      <div class="men_fr" style="width: 100%;" v-if="!report">
        <a @click="give_share = true">完成能力优势探索，解锁完整版报告</a>
      </div>
      <div class="men_fr" style="width: 100%;" v-else>
        <a @click="give_share = true">分享测评给好友</a>
      </div>
    </div>
    <img class="give_share" alt="分享图片" src="@a/popse.png" v-show="give_share" @click="give_share = false">
  </div>
</template>
<script>
import {
  measurement_reprot
} from "@/api/measurement";
import PublicAdvertising from "@c/measurement/public-advertising";
import PublicAdQrcode from "@c/measurement/public-ad-qrcode";
import PublicTopTips from "@c/measurement/public-top-tips";
import { shareCon } from "@/utils/wxconfig";
export default {
  data() {
      return {
        body_show: false,
        data: {},
        title: "",
        report: false,
        userinfo: {},
        ability: [],
        assistance: [],
        num: "",
        give_share: false,
        group: {},
        model1: {},
        model2: {},
        model3: {},
        onekey: [],
        onekey_f: {
          '个人战略': '如果你希望能够在最快时间内，完成职业发展的定位、清晰目标，提升自己的职场身价，建议你参与古典老师亲自研发并讲授的「个人战略」课，用30天时间，制定一份未来2~3年的个人发展方案。课程是国内首个职业类PBL（Project Based Learning）项目式学习方式，真正帮你从”知道“到”做到“。',
          '1对1辅导': '也可以直接对接行业专家和生涯规划师，1对1帮你梳理个人发展，提高职业竞争力，更上一层楼。'
        },
        type_obj: {evaluation_id:"",evaluation_name:"",evaluation_id:"",nickname:""}
      }
    },
    components:{
      PublicAdvertising,
      PublicAdQrcode,
      PublicTopTips,
    },
    methods: {
      // 广告跳转
			toViewHandle(link){
				window.location.href = link;
			},
      pullData() {
        measurement_reprot({
            cid: this.$route.query.cid,
            uid: this.$route.query.uid
          })
          .then((data) => {
            if(typeof data !== 'string'){
              this.body_show = true;
              document.title = data.headtitle;
              let list = data.list;
              this.ability = data.ability;
              this.title = data.title;
              this.num = data.num;
              this.onekey = data.onekey;
              this.report = data.report;
              this.assistance = data.assistance;
              this.userinfo = list.userinfo;
              this.group = list.group;
              this.model1 = list.model1;
              this.model2 = list.model2;
              this.model3 = list.model3;
              // 给分享js传值
              this.type_obj.evaluation_id = this.$route.query.cid;
              this.type_obj.evaluation_name = data.headtitle;
              this.type_obj.evaluation_user_id = this.$route.query.uid;
              this.type_obj.nickname = list.userinfo.nickname;
              this.type_obj.path = this.$route.path;
              shareCon("measurement",this,this.type_obj);

              this.data = data;
            }else {
              location.href = data;
            }

          })

      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
// 9.9职业发展广告
.career-dev {
  width: changeRem(13.8) + px;
  border-radius: changeRem(.16) + px;
  background-color: #ffffff;
  margin: 30px auto 0;
  .More-main {
    box-shadow: 0px 1px 8px 2px rgba(235, 80, 50, 0.14);
    border-radius: 12px;
    padding: 40px;
    .title {
      text-align: center;
      margin-bottom: 30px;
      font-size: 36px;
      color: #333333;
    }
    ul {
      display: flex;
      flex-direction: column;
      li {
        display: flex;
        img {
          width: 282px;
          height: 176px;
          margin-right: 50px;
        }
        .flex-text {
          flex: 1;
          h3 {
            font-weight: bold;
            font-size: 32px;
            line-height: 40px;
            text-align: left;
            color: #333333;
          }
          a {
            display: block;
            border-radius: 25px;
            background-color: #eb5032;
            color: #ffffff;
            width: 188px;
            line-height: 50px;
            margin-top: 15px;
            font-size: 26px;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
@import "@s/remChange.scss";
.men_detail {
  width: 100%;
  text-align: center;
  img {
    width: 100%;
  }
}

.men_foots {
  width: 100%;
  height: changeRem(1.96) + px;
  line-height: changeRem(1.96) + px;
  position: fixed;
  bottom: 0;
  left: 50%;
  margin-left: -375px;
  max-width: 750px;
  text-align: center;
  background: #EB5032;
  z-index: 2;
  color: #fff;
  font-size: changeRem(0.68) + px;
  a {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.meacur_top {
  background: url(../../../assets/measue_bg.png) no-repeat top center;
  background-size: cover;
  width: 100%;
  height: changeRem(8.28) + px;
  padding: 0 changeRem(.6) + px;
  padding-top: changeRem(.65) + px;
  text-align: left;
  h2 {
    font-size: changeRem(1.08) + px;
    line-height: changeRem(1.6) + px;
    color: #fff;
    width: changeRem(8.8) + px;
    font-weight: bold;
  }
}

.meacur_tx {
  margin-top: changeRem(.6) + px;
  img {
    border-radius: 50%;
    width: changeRem(2) + px;
    height: changeRem(2) + px;
    float: left;
  }
}

.meacur_txr {
  float: left;
  margin-left: changeRem(.5) + px;
  h3 {
    color: #fff;
    font-size: changeRem(.64) + px;
    line-height: changeRem(1.1) + px;
  }
  h4 {
    color: #fff;
    font-size: changeRem(.52) + px;
    line-height: changeRem(.7) + px;
  }
}

.meacur_main {
  width: changeRem(13.8) + px;
  background: #fff;
  border-radius: changeRem(.16) + px;
  margin: 0 auto;
  margin-top: changeRem(.8) + px;
  padding: changeRem(1.2) + px changeRem(.6) + px;
  text-align: center;
}

.mea_tb {
  background: url(../../../assets/ma_bg.png) no-repeat top center;
  background-size: cover;
  width: changeRem(11.72) + px;
  line-height: changeRem(1.2) + px;
  height: changeRem(1.2) + px;
  margin: 0 auto;
  text-align: center;
  color: #fff;
  font-size: changeRem(.72) + px;
  font-weight: bold;
}

.mea_h2 {
  line-height: changeRem(.8) + px;
  color: #666;
  font-size: changeRem(.52) + px;
  text-align: justify;
  margin: changeRem(.8) + px 0;
}

.meacut_t1 {
  text-align: left;
  border-bottom: 2px dashed #ccc;
  .meacut_zk {
    width: 100%;
    margin-top: changeRem(1) + px;
    h4 {
      font-size: changeRem(.48) + px;
      text-align: left;
      color: #333;
      line-height: changeRem(1) + px;
      width: 100%;
    }
    .zk {
      width: changeRem(11) + px;
      height: changeRem(11) + px;
      border-left: changeRem(.04) + px solid #EB5032;
      border-bottom: changeRem(.04) + px solid #EB5032;
      padding: changeRem(.44) + px;
      margin-left: changeRem(.68) + px;
      li {
        float: left;
        width: 50%;
        img {
          width: 100%;
          vertical-align: middle;
        }
      }
    }
    .rig {
      text-align: right;
    }
  }
  .mea_vb {
    margin-top: changeRem(.35) + px;
    color: #333;
    font-weight: bold;
    text-align: justify;
    font-size: changeRem(.52) + px;
    span {
      color: #EB5032;
    }
  }
  .mea_fov {
    margin-top: changeRem(.3) + px;
  }
}

.mea_fot {
  margin-top: changeRem(.8) + px;
  width: 100%;
}

.meacur_dv {
  width: 100%;
  position: relative;
  margin-top: changeRem(.96) + px;
  h4 {
    color: #333;
    font-size: changeRem(.48) + px;
    padding-left: changeRem(2.2) + px;
    padding-bottom: changeRem(.2) + px;
  }
  .dv_top {
    position: absolute;
    right: 0;
    top: changeRem(.08) + px;
    font-size: changeRem(.4) + px;
    color: #333;
    line-height: 0;
    span {
      display: inline-block;
      width: changeRem(.56) + px;
      height: changeRem(.24) + px;
      background: rgba(238, 238, 238, 1);
      margin-right: changeRem(.2) + px;
      vertical-align: middle;
    }
  }
  .dv_top1 {
    right: changeRem(4.2) + px;
    span {
      background-color: #6DABF1;
    }
  }
  .dv_top2 {
    right: changeRem(2) + px;
    span {
      background-color: #EF735B;
    }
  }
  .dv_left {
    float: left;
    width: changeRem(2.6) + px;
    font-size: changeRem(.48) + px;
    text-align: right;
    padding-top: changeRem(.1) + px;
    height: changeRem(1.76) + px;
  }
  .dv_right {
    width: changeRem(9.6) + px;
    float: right;
    border-left: changeRem(.04) + px solid #F57F17;
    position: relative;
    height: changeRem(1.76) + px;
    h2 {
      height: changeRem(.56) + px;
      background: #EF735B;
      position: relative;
      z-index: 1;
    }
    h2.sum {
      background-color: #6DABF1;
    }
    h2.spe {
      background-color: #eee;
    }
    dl {
      position: absolute;
      z-index: 0;
      top: 0;
      left: 0;
      dt {
        width: changeRem(1.68) + px;
        border-right: changeRem(.04) + px dashed #eee;
        float: left;
        height: changeRem(1.72) + px;
      }
      dt.m1_dt {
        border-right-color: #F57F17;
      }
    }
    dl.dl1 {
      top: changeRem(.6) + px;
      dt {
        height: changeRem(2.04) + px;
      }
    }
  }
  .dv_left1 {
    height: changeRem(2.68) + px;
    padding-top: changeRem(.92) + px;
  }
  .dv_right1 {
    height: changeRem(2.68) + px;
    padding-top: changeRem(.92) + px;
  }
  .dv_right2 {
    border-bottom: changeRem(.04) + px solid #F57F17;
  }
  .dv_bottom {
    width: changeRem(9.6) + px;
    float: right;
    margin-top: changeRem(.2) + px;
    position: relative;
    li {
      margin-left: changeRem(2.96) + px;
      color: #333;
      font-size: changeRem(.44) + px;
      text-align: center;
      float: left;
    }
    li.b2 {
      margin-left: changeRem(4.25) + px;
    }
    li.b3 {
      position: absolute;
      right: changeRem(-0.3) + px;
      bottom: 0;
    }
    li.b4 {
      margin-left: changeRem(2.65) + px;
    }
    li.b5 {
      margin-left: changeRem(2.3) + px;
    }
  }
}

.mea_h2s {
  margin-bottom: 10px;
  span {
    color: #EB5032;
  }
}

.yos {
  width: 100%;
  margin-top: changeRem(0.8) + px;
  .yos_main {
    width: changeRem(3) + px;
    margin-right: changeRem(0.2) + px;
    text-align: center;
    float: left
  }
  .yos_mainlast {
    margin-right: 0
  }
}

.yos .yos_main h2 {
  line-height: changeRem(1) + px;
  font-size: changeRem(0.52) + px;
  color: #333;
  font-weight: bold
}

.yos .yos_main ul li {
  width: 100%;
  position: relative;
  height: changeRem(3) + px;
  background: #ccc;
  margin-top: changeRem(0.2) + px
}

.yos .yos_main ul li .yos_k {
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  left: 0;
  color: #fff;
  font-size: changeRem(0.52) + px;
  line-height: changeRem(1) + px
}

.yos .yos_main ul li.sun1 {
  background-color: #F39684
}

.yos .yos_main ul li.sun2 {
  background-color: #EF735B
}

.yos .yos_main ul li.sun3 {
  background-color: #EB5032
}

.jas_main {}

.jas_main h2 {
  color: #EB5032;
  font-size: changeRem(0.64) + px;
  text-align: left;
  line-height: changeRem(0.85) + px;
  padding-top: changeRem(0.8) + px;
  border-top: 2px solid #ccc
}

.jas_main ul.j_v li {
  padding-bottom: changeRem(0.8) + px;
  border-bottom: 2px solid #ccc
}

.jas_main ul.j_v li:last-child {
  padding-bottom: 0;
  border-bottom: none
}

.jas_main ul.j_v li img {
  float: left;
  width: changeRem(5.8) + px
}

.jas_main ul.j_v li .jas_r {
  width: changeRem(6.1) + px;
  float: right
}

.jas_main ul.j_v li .jas_r h3 {
  line-height: changeRem(0.8) + px;
  font-size: changeRem(0.64) + px;
  color: #333;
  text-align: left
}

.jas_main ul.j_v li .jas_r a {
  display: block;
  line-height: changeRem(1) + px;
  font-size: changeRem(0.64) + px;
  width: changeRem(3.76) + px;
  color: #fff;
  margin-top: changeRem(1.2) + px;
  border-radius: changeRem(0.5) + px;
  background: #EB5032
}

.jas_main ul.cep {
  margin-top: changeRem(0.88) + px
}

.jas_main ul.cep li {
  width: changeRem(1.6) + px;
  float: left;
  text-align: center
}

.jas_main ul.cep li img {
  width: changeRem(1.6) + px
}

.jas_main ul.cep li p {
  color: #999;
  font-size: changeRem(0.52) + px
}

.jas_main ul.cep li:nth-child(even) {
  width: changeRem(3.72) + px;
  padding-top: changeRem(0.8) + px
}

.jas_main ul.cep li:nth-child(even) h4 {
  width: 100%;
  height: changeRem(0.04) + px;
  background: #ccc
}

.jas_main ul.cep li:last-child {
  width: changeRem(2.1) + px;
  text-align: left
}

.jas_main ul.cep li.spe {
  width: changeRem(3.55) + px
}

.jas_main ul.cep li:last-child p {
  margin-left: changeRem(-0.2) + px
}

.jas_main ul.cep li.on p {
  color: #F57F17
}

.jas_main ul.cep li:nth-child(even).on h4 {
  background-color: #F57F17
}

.jas_v {
  width: 100%;
  margin-top: changeRem(0.8) + px
}

.jas_v h2 {
  font-size: changeRem(0.64) + px;
  color: #333;
  text-align: left
}

.jas_v ul {
  margin-top: changeRem(0.6) + px;
  width: auto;
  overflow-x: scroll;
  display: flex
}

.jas_v li {
  width: changeRem(1.2) + px;
  margin-right: 0;
  float: left;
  margin-right: changeRem(0.6) + px;
  text-align: center
}

.jas_v li img {
  width: changeRem(1.2) + px;
  height: changeRem(1.2) + px;
  border-radius: 50%
}

.jas_v li p {
  font-size: changeRem(0.4) + px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%
}
img.give_share {
  width: 100%;
  position: fixed;
  top: 0;
  left: 50%;
  z-index: 1000;
  height: 100%;
  max-width: 750px;
  margin-left: -375px;
}

</style>
